(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name flightPunctuality.controller:DelayCodesModalCtrl
	 * 
	 * @description
	 * 
	 */
	angular
		.module('flightPunctuality')
		.controller('delayCodesPopupCtrl', delayCodesPopupCtrl);

	function delayCodesPopupCtrl($uibModalInstance, modalParams) {
		var vm = this;

		vm.model = {
			delayCodeList: modalParams.delayCodes
		};

		vm.closeMe = function() {
			$uibModalInstance.close();
		}; 
	}
}());